import { esApp } from './plataforma';

/**
 * Dentro de la app, la ÚNICA forma de abrir una dirección de fuera: navegar a ella. Capacitor
 * atiende en los dos sistemas cualquier navegación a una dirección de fuera mandándola al navegador
 * del sistema, y la app se queda donde estaba. Si algún día se cambia de método (por ejemplo,
 * `@capacitor/browser`), se cambia aquí.
 */
export const enviarAlNavegadorDelSistema = (url: string): void => {
	window.location.assign(url);
};

/**
 * Abrir una dirección de fuera (el KYC, una firma) cuando se conoce DESPUÉS de hablar con el
 * servidor.
 *
 * En la web es una pestaña nueva, como siempre. En la app no vale `window.open`: para cuando llega
 * la respuesta, el toque del usuario ya ha caducado, y iOS no abre ventanas fuera de un toque
 * —devuelve `null` y el botón no hace nada—. Se navega a la dirección: Capacitor atiende en los dos
 * sistemas cualquier navegación a una dirección de fuera mandándola al navegador del sistema, y la
 * app se queda donde estaba.
 *
 * Un `window.open` que se ejecuta dentro del propio toque (un enlace, un botón sin espera) sí
 * funciona en la app y no necesita pasar por aquí.
 */
export const abrirEnElNavegador = (url: string): void => {
	if (esApp()) {
		enviarAlNavegadorDelSistema(url);
		return;
	}

	window.open(url, '_blank', 'noopener,noreferrer');
};

/**
 * Ir a una web de fuera en la MISMA pestaña (la firma del boletín, el mini-KYC del IBAN), que al
 * terminar vuelve a nuestra dirección.
 *
 * En la web la página se va, y con ella la ruedecita del botón. En la app no: Capacitor manda la
 * dirección al navegador del sistema y la app se queda donde estaba. Por eso se llama a
 * `alSeguirEnLaApp`, para que quien llama pare su ruedecita; si no, al volver seguiría girando y
 * bloqueando el botón.
 */
export const irAUnaWebDeFuera = (url: string, alSeguirEnLaApp: () => void): void => {
	window.location.assign(url);

	if (esApp()) {
		alSeguirEnLaApp();
	}
};
